import {queryClient} from "@app/appProvider/queryClient/queryClient";
import {
	QUERY_KEY_DEVICES_BY_GROUP,
	QUERY_KEY_GROUPS, QUERY_KEY_MAP_GROUPS, QUERY_KEY_RELATED_GROUPS_BY_GROUP_MULTI_ID
} from "@containers/account/containers/group/hooks/constants/queryKey";
import {QUERY_KEY_CAMERAS, QUERY_KEY_CAMERAS_DASHBOARD} from "@containers/cameras/queryHooks/constants/queryKey";

export const refetchCameras = ()=>{
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_GROUPS]});
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_DEVICES_BY_GROUP]});
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_RELATED_GROUPS_BY_GROUP_MULTI_ID]});
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_MAP_GROUPS]});
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_CAMERAS]});
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_CAMERAS_DASHBOARD]});
}